<template>
  <div class="loader text-center">
    <div class="lds-facebook form-loader">
      <div />
      <div />
      <div />
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseLoader'
}
</script>

<style scoped lang='scss'>
.loader .lds-facebook {
  display: inline-block;
  position: relative;
  width: 64px;
  height: 64px;
  margin: 10px;
  div {
    display: inline-block;
    position: absolute;
    left: 6px;
    width: 13px;
    background: lightgray;
    animation: lds-facebook 1.2s cubic-bezier(0, 0.5, 0.5, 1) infinite;
  }
  div:nth-child(1) {
    left: 6px;
    animation-delay: -0.24s;
  }

  div:nth-child(2) {
    left: 26px;
    animation-delay: -0.12s;
  }

  div:nth-child(3) {
    left: 45px;
    animation-delay: 0;
  }
}

.loader.light .lds-facebook div {
  background: lightgray;
}

@keyframes lds-facebook {
  0% {
    top: 6px;
    height: 51px;
  }
  50%,
  100% {
    top: 19px;
    height: 26px;
  }
}
</style>
